import PropTypes from 'prop-types';
import {Component} from 'react';
import {BlockPicker} from 'react-color';
import {Image} from 'semantic-ui-react';
import editIcon from '../images/editIcon.svg';
import './ThemeColour.css';

export default class ThemeColour extends Component {
  static propTypes = {
    colour: PropTypes.string.isRequired,
    colours: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    onChange: PropTypes.func.isRequired,
  };

  state = {
    showColourPicker: false,
  };

  showColorPicker = (showColourPicker) => (e) => {
    e.stopPropagation();
    this.setState({showColourPicker});
  };

  render() {
    const {colour, colours, onChange} = this.props;
    const {showColourPicker} = this.state;

    return (
      <div className="theme-colour" style={{display: 'flex'}}
           onClick={this.showColorPicker(true)}>
        <div
          className="theme-button"
          style={{background: colour}}
         />
        {showColourPicker && (
          <div>
            <div className="clickterceptor" onClick={this.showColorPicker(false)}/>
            <BlockPicker colors={colours} color={colour} onChangeComplete={onChange}/>
          </div>
        )}
        <div>
          Select Colour
          <Image style={{verticalAlign: 'baseline', height: '1.5rem'}} src={editIcon} alt=""/>
        </div>
      </div>
    );
  }
}